import type Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import JournalTemplateModel from 'donor-elf-web/models/journal-template';
import type FundsService from 'donor-elf-web/services/funds-service';
import type JournalService from 'donor-elf-web/services/journal-service';
import type NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import type TaskService from 'donor-elf-web/services/task-service';

export interface JournalEditRouteModel {
  journalInfo: any;
  template: JournalTemplateModel;
}

export default class JournalEditRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare journalService: JournalService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare taskService: TaskService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Edit Journal';
  }

  async model(): Promise<JournalEditRouteModel> {
    await this.fundsService.confirmValidFundToken();
    await this.taskService.load();
    await this.journalService.load();
    let journalId = (this.paramsFor('funds.fund.journals.journal') as any)
      .journalId;
    let journalInfo = this.journalService.journalInfoById(journalId);
    let templates = (await this.store.query('journal-template', {})).slice();
    // get org specific template
    let template =
      templates.find((x) => isEmpty(x.fundGroupId)) || templates[0];
    return {
      journalInfo,
      template,
    };
  }
}
